<template>
  <div class="tag-box">
    <div class="tag-item" :class="showClose ? 'tag-item-close' : ''" v-for="(item, index) in tagList" :key="index"
      v-tooltip="{
        content: getHtml(item),
        html: true,
        popperClass: 'tag-item-tooltip',
        disabled: type !== 5,
        triggers: ['hover', 'focus', 'touch'],
      }">
      <div class="van-ellipsis">{{ item.name }}</div>
      <div class="close-box" v-if="showClose" @click="remove(item.id)">
        <van-icon name="cross" />
      </div>
    </div>
  </div>
</template>
<script>
import { timeFormat } from "@/utils/baseFormat";
export default {
  name: "BaseAddTag",
  props: {
    // 1 其他标签 2 病种分类 3 西医诊断 4 藏医诊断 5 主诉症状
    type: {
      type: Number,
      default: 1,
    },
    tagList: {
      type: Array,
      default: () => [],
    },
    showClose: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {};
  },
  computed: {
    baseInfo() {
      const typeSettings = {
        1: {
          title: "其他标签",
        },
        2: {
          title: "病种分类",
        },
        3: {
          title: "西医诊断",
        },
        4: {
          title: "藏医诊断",
        },
        5: {
          title: "主诉症状",
        },
      };
      return typeSettings[this.type];
    },
  },
  created() { },
  mounted() { },
  methods: {
    remove(id) {
      this.$emit("removeTag", id);
    },
    getHtml(item) {
      return `<div class='tooltip-box'>
                        <div class="tooltip-item">
                            <div>开始时间：</div>
                            <div>${timeFormat(item.startTime) || "-"}</div>
                        </div>
                        <div class="tooltip-item">
                            <div>结束时间：</div>
                            <div>${timeFormat(item.endTime) || "-"}</div>
                        </div>
                        <div class="tooltip-item">
                            <div>备注：</div>
                            <div>${item.remark || "-"}</div>
                        </div>
                    </div>`;
    },
  },
};
</script>

<style lang="scss">
.tag-item-tooltip {

  .v-popper__arrow-outer {
    border-color: rgba(0, 0, 0, .9) !important;
  }

  .v-popper__inner {
    margin: 0 5px;
    background: rgba(0, 0, 0, .9) !important;
  }

  .tooltip-box {
    max-width: 80vw;
    overflow: hidden;

    .tooltip-item {
      display: flex;

      &+.tooltip-item {
        margin-top: 8px;
      }

      div {
        font-size: 14px;

        &+div {
          flex: 1;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.tag-box {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  font-weight: normal;
  overflow: hidden;

  .tag-item {
    background: #eff3fb;
    border-radius: 4px;
    border: 1px solid #0082ef;
    padding: 5px 15px;
    color: #0082ef;
    margin-right: 12px;
    margin-bottom: 10px;
    font-size: 14px;
    display: flex;
    align-items: center;
    overflow: hidden;
    cursor: pointer;

    &.tag-item-close {
      padding: 0 3px 0 15px;
    }

    .close-box {
      cursor: pointer;
      padding: 5px 12px;
    }
  }
}
</style>
